type DateDiffType = 'day' | 'month' | 'year';

type DateOrString = Date | string;

export default function calculateDateDiff(startDate: DateOrString, endDate: DateOrString, type: DateDiffType = 'day') {
	const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
	const end = typeof endDate === 'string' ? new Date(endDate) : endDate;

	let divider = 1000 * 60 * 60 * 24; // day
	if (type === 'month') divider *= 30;
	else if (type === 'year') divider *= 365;

	return Math.ceil((end.getTime() - start.getTime()) / divider);
}
